module.exports = __webpack_public_path__ + "img/list-slider.6f65bf08.svg";